export const centeredFieldStyles = {
  fill: true,
  style: { display: 'grid', gridTemplateColumns: 'minmax(200px, 1fr) 320px 1fr' },
};

export const EMAIL_QUERY_KEY = 'email';
export const USERNAME_QUERY_KEY = 'username';
export const IS_FORGOT_PASSWORD_KEY = 'forgot-password';

export enum SignInErrorCode {
  UNCONFIRMED_USER_ERROR_CODE = '40108',
  UNVERIFIED_EMAIL_ERROR_CODE = '40111',
  ATTEMPTS_LIMIT_ERROR_CODE = '40111',
  FORGOT_USERNAME_ATTEMPTS_LIMIT_ERROR_CODE = '42900',
  INVALID_USER_NAME_ERROR_CODE = '40001',
  TOO_MANY_ATTEMPTS_ERROR_CODE = '42200',
}